import * as Yup from 'yup';
import { getRequiredMessage } from 'views/declarations/utils/validation-utils';
import { ALLOWED_NEW_MEMBER_ROLES, AssignTeamManagerFieldValues, NewTeamMemberFormValues } from './types';

export const newTeamFormValidationSchema = Yup.object({
    name: Yup.string().trim().nullable().required(getRequiredMessage('name')),
    market: Yup.string().trim().nullable().required(getRequiredMessage('market')),
});

export const assignTeamManagerValidationSchema = Yup.object({
    teamManagerId: Yup.mixed<AssignTeamManagerFieldValues['teamManagerId']>().test(
        'select-or-create-team-manager',
        'Please either select an existing Team Manager OR enter name and email to create one',
        function (value) {
            const { name, email } = this.parent as AssignTeamManagerFieldValues;
            const hasNewUserData = !!name || !!email;
            const hasSelectedTeamManager = !!value;
            if ((hasNewUserData && hasSelectedTeamManager) || (!hasNewUserData && !hasSelectedTeamManager)) {
                return false;
            }
            return true;
        }
    ),
    name: Yup.string().when('teamManagerId', {
        is: (val: any) => !val,
        then: Yup.string().required(getRequiredMessage('name')).nullable(),
        otherwise: Yup.string().nullable(),
    }),
    email: Yup.string().when('teamManagerId', {
        is: (val: any) => !val,
        then: Yup.string().email('Invalid email').required(getRequiredMessage('email')).nullable(),
        otherwise: Yup.string().nullable(),
    }),
});

export const newTeamMemberValidationSchema = Yup.object().shape({
    assignee: Yup.mixed<NewTeamMemberFormValues['assignee']>().test(
        'assign-or-manual-exclusive',
        'Please either select an existing member OR fill in all manual details.',
        function (value) {
            const { name, email, role } = this.parent as NewTeamMemberFormValues;

            const hasManual = !!name || !!email || !!role;
            const hasAssign = !!value;

            if ((hasManual && hasAssign) || (!hasManual && !hasAssign)) {
                return false;
            }

            return true;
        }
    ),
    name: Yup.string().when('assignee', {
        is: (val: any) => !val,
        then: Yup.string().required(getRequiredMessage('name')).nullable(),
        otherwise: Yup.string().nullable(),
    }),
    email: Yup.string().when('assignee', {
        is: (val: any) => !val,
        then: Yup.string().email('Invalid email').required(getRequiredMessage('email')).nullable(),
        otherwise: Yup.string().nullable(),
    }),
    role: Yup.string().when('assignee', {
        is: (val: any) => !val,
        then: Yup.string()
            .oneOf(ALLOWED_NEW_MEMBER_ROLES, 'Invalid role')
            .required(getRequiredMessage('role'))
            .nullable(),
        otherwise: Yup.string().nullable(),
    }),
});
